import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { trackPageView } from './services/analytics.js';
import LandingPage from './pages/LandingPage.js';
import AboutPage from './pages/AboutPage.js';
import FeaturesPage from './pages/FeaturesPage.js';
import Onboarding from './pages/Onboarding.js';
import PolicyPage from './pages/PolicyPage.js';
import HomePage from './components/Website/HomePage.js';
import Dashboard from './components/Admin/Dashboard.js';
import Subscription from './components/Admin/Subscription.js';
import PageEditor from './components/Admin/PageEditor.js';
import Login from './pages/Login.js';
import PrivateRoute from './components/Admin/PrivateRoute.js';
import ImageArchive from './components/Admin/ImageArchive.js';
import WebsiteSettings from './components/Admin/WebsiteSettings.js';
import FAQPage from './pages/FAQPage.js';
import IncludedInPrice from './pages/IncludedInPrice.js';
import BenefitsPage from './pages/BenefitsPage.js';
import BlogPage from './pages/BlogPage.js';
import BlogPost from './components/Blog/BlogPost.js';
import NotFoundPage from './pages/NotFoundPage.js';
import TradeLandingPage from './pages/TradeLandingPage.js';
import ContactPage from './pages/ContactPage.js';

// Create a new component that uses location
function AppRoutes() {
  const location = useLocation();
  
  // Get subdomain logic
  const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    if (parts.length > 2 && hostname.includes('xn--hndvrkernet-x8aq.dk')) {
      return parts[0];
    }
    return null;
  };

  const subdomain = getSubdomain();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <Routes>
      {subdomain ? (
        <>
          <Route path="/admin" element={<Login />} />
          <Route path="/admin" element={<PrivateRoute />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="pages" element={<PageEditor />} />
            <Route path="images" element={<ImageArchive />} />
            <Route path="settings" element={<WebsiteSettings />} />
          </Route>
          <Route path="/" element={<HomePage subdomain={subdomain} />} />
          <Route path="/:slug" element={<HomePage subdomain={subdomain} />} />
          <Route path="/privacy" element={<PolicyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/hvad-er-med-i-prisen" element={<IncludedInPrice />} />
          <Route path="/hvorfor-hjemmeside-haandvaerker" element={<BenefitsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={<LandingPage />} />
          <Route path="/om" element={<AboutPage />} />
          <Route path="/funktioner" element={<FeaturesPage />} />
          <Route path="/onboarding" element={<Onboarding />} />

          {/* Trade landing pages - Tilføj eksakte stier */}
          <Route exact path="/tomrer-hjemmeside" element={<TradeLandingPage trade="tomrer-hjemmeside" />} />
          <Route exact path="/murer-hjemmeside" element={<TradeLandingPage trade="murer-hjemmeside" />} />
          <Route exact path="/vvs-hjemmeside" element={<TradeLandingPage trade="vvs-hjemmeside" />} />
          <Route exact path="/maler-hjemmeside" element={<TradeLandingPage trade="maler-hjemmeside" />} />
          <Route exact path="/vinduespudser-hjemmeside" element={<TradeLandingPage trade="vinduespudser-hjemmeside" />} />
          <Route exact path="/mekaniker-hjemmeside" element={<TradeLandingPage trade="mekaniker-hjemmeside" />} />
          <Route exact path="/elektriker-hjemmeside" element={<TradeLandingPage trade="elektriker-hjemmeside" />} />

          {/* Catch-all company route skal være efter de specifikke ruter */}
          <Route path="/:cvr/*" element={<HomePage />} />

          <Route path="/:cvr/:slug" element={<HomePage />} />
          <Route path="/admin" element={<Login />} />
          <Route path="/admin" element={<PrivateRoute />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="subscription" element={<Subscription />} />
            <Route path="pages" element={<PageEditor />} />
            <Route path="images" element={<ImageArchive />} />
            <Route path="settings" element={<WebsiteSettings />} />
          </Route>
          <Route path="/privacy" element={<PolicyPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/hvad-er-med-i-prisen" element={<IncludedInPrice />} />
          <Route path="/hvorfor-hjemmeside-haandvaerker" element={<BenefitsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </>
      )}
    </Routes>
  );
}

// Main App component
function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;